import {
  Box,
  Button,
  Grid2,
  Typography,
  Paper,
  Divider,
  InputBase
} from "@mui/material";
import { backendHosts } from "../../../ui-utils/apiConfig"
import HomePageStyles from "./HomeWeb.module.css";
import { useState, useEffect } from "react";
import validator from "validator";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { motion, AnimatePresence } from "framer-motion";
import bb from "../../../ui-utils/latestPics/bb.svg"
import { useLanguage } from "../../../Context/LangContext";


import en from "../../../i18n/English/Home/home.json";
import hi from "../../../i18n/Hindi/Home/home.json";
import kn from "../../../i18n/Kannada/Home/home.json";
import ma from "../../../i18n/Marathi/Home/home.json";
import gu from "../../../i18n/Gujarati/Home/home.json"

export default function HomeWeb() {
  const [mobileNo, setMobileNo] = useState("");
  const clientErr = {};
  const [mobClientErr, setMobileClientErr] = useState({});

  const { language } = useLanguage();
  const translations = { en, hi, kn, gu, ma };
  const t = translations[language];

  const handleMobilenoEnter = () => {
    const formData = { mobileNo };
    console.log(formData);
    const runValidation = () => {
      if (mobileNo.trim().length == 0) {
        clientErr.mobileNo = "Please Enter your mobile number";
        return;
      }
      if (!validator.isMobilePhone(mobileNo, "en-IN")) {
        console.log("false")
        clientErr.mobileNo = "Please Enter Valid mobile number";
        return;
      }
    };
    runValidation();
    if (Object.keys(clientErr).length == 0) {

      const fullUrl = `${backendHosts.REG}/?mobilenofromhome=${mobileNo}&t=${Date.now()}`;
      window.location.href = fullUrl;
      setMobileClientErr({});

    } else {
      setMobileClientErr(clientErr);
    }
  };

  const handleMobileNoChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, "");
    const limitedValue = numericValue.slice(0, 10);

    setMobileNo(limitedValue);
  };



  const [isImageLoaded, setIsImageLoaded] = useState(false);


  return (
    <>
      <Box className={HomePageStyles.HomeSectionBox}>
        {/* <video
          className={HomePageStyles.video}
                                autoPlay
                                loop
                                muted
                                playsInline
                                controls={false}
                            >
                                <source src={bg} type="video/mp4" />

        </video> */}

        {/* <img
          src={images[currentImage]}
          alt="Background slideshow"
          className={HomePageStyles.bgImage}
        /> */}

        {/* <AnimatePresence mode="wait">
          <motion.img
            key={currentImage}
            src={images[currentImage]}
            alt="Background"
            className={HomePageStyles.bgImage}
            initial={{ opacity: 0.6 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0.6 }}
            transition={{ duration:0.8, ease: "easeInOut" }}
          />
        </AnimatePresence> */}

        <img
          src={bb}
          alt="Background slideshow"
          className={`${HomePageStyles.bgImage} ${isImageLoaded ? HomePageStyles.animate : ''}`}
          onLoad={() => setIsImageLoaded(true)}
        />




        <Box className={HomePageStyles.HomeContentWrapper}>
          <motion.div
            initial={{ opacity: 0, x: -300 }}   // far off-screen
            animate={{ opacity: 1, x: 0 }}      // animates into position
            transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
          >

            <Typography className={HomePageStyles.homeHeading} style={{ fontWeight: 600 }}>

              {t.heading}
            </Typography>

            <Typography
              className={HomePageStyles.homeSubHeading}
              sx={{ lineHeight: "1.5", }} // restrict width to wrap
            >

              {t.points[0]}
            </Typography>

            <Typography
              className={HomePageStyles.homeSubHeading1}
              sx={{ lineHeight: "1.5" }}
            >

              {t.points[1]}
            </Typography>


            <Paper component="form" className={HomePageStyles.mobilefield}>
              <Typography className={HomePageStyles.preMobile}>
                91
              </Typography>

              <Divider
                className={HomePageStyles.divider}
                orientation="vertical"
              />

              <InputBase
                className={HomePageStyles.inputbase}
                name="mobileNo"
                type="tel"
                placeholder={t.placeholder}
                autoComplete="tel-national"
                inputProps={{
                  "aria-label": "Mobile Number",
                  inputMode: "numeric",
                }}
                value={mobileNo}
                onChange={handleMobileNoChange}
              />

              <Button
                type="button"
                className={HomePageStyles.dematButton}
                onClick={handleMobilenoEnter}
              >
                {t.dematButton}
              </Button>
            </Paper>
            {mobClientErr.mobileNo && (
              <Typography className={HomePageStyles.errMsgg}>{mobClientErr.mobileNo}</Typography>
            )}

          </motion.div>
        </Box>

        {/* </Grid2> */}
      </Box>
    </>
  );
}
